type SaveIndicatorOptions = {
    isSaved: boolean;
    hasError?: boolean;
};

type SaveIndicatorState = {
    textKey: "saved" | "save_failed";
    className: string;
};

export function getSaveIndicatorState({
    isSaved,
    hasError,
}: SaveIndicatorOptions): SaveIndicatorState | null {
    if (hasError) {
        return {
            textKey: "save_failed",
            className: "text-red-600 dark:text-red-400",
        };
    }

    if (isSaved) {
        return {
            textKey: "saved",
            className: "text-emerald-600 dark:text-emerald-400",
        };
    }

    return null;
}
